import React, { useEffect } from 'react';
import { MessengerName, MessengerSwitch } from '../../../../../base/components/MessengerSwitch';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { settingsActions } from '../../redux/slice/settingsSlice';

import './styles.scss';

export const MessengerNotificationsToggle = () => {
    const dispatch = useAppDispatch();
    const notificationMessengers = useAppSelector((state) => state.workerAppSettings.notificationMessengers);

    useEffect(() => {
        dispatch(settingsActions.getNotificationMessengers());
    }, []);

    const onMessengerClick = (id: number) => {
        dispatch(settingsActions.toggleNotificationsMessenger(id));
    };

    if (!notificationMessengers.length) {
        return null;
    }

    return (
        <div className='messenger-notification-toggle'>
            <h5 className='messenger-notification-toggle__title'>
                {__t('Уведомления о новых сообщениях, приглашениях на работу и вакансиях')}
            </h5>
            {notificationMessengers.map((messenger) => (
                <div
                    onClick={() => onMessengerClick(messenger.id)}
                    className='messenger-notification-toggle__messenger'
                    key={messenger.id}
                >
                    <MessengerSwitch
                        checked={messenger.isActive}
                        type={messenger.name.toLowerCase() as MessengerName}
                    />
                </div>
            ))}
        </div>
    );
};
